export const convertCreateBonusGift = data => {
  // const image = data.imageData.image.split(',')[1];
  const image = data.imageData.image;

  const bodyData = new FormData();
  bodyData.append('gift_name', data.name);
  bodyData.append('gift_point_cost', Number(data.points));
  bodyData.append('gift_description', data.description);
  bodyData.append('gift_status', data.active);
  bodyData.append('gift_image', image);
  bodyData.append('id', data.id);

  return bodyData;

  // return ({
  //   gift_name: data.name,
  //   gift_point_cost: Number(data.points),
  //   gift_description: data.description,
  //   gift_status: data.active,
  //   gift_image: image || undefined,
  //   // gift_ext: data.imageData.ext,
  //   id: data.id,
  // })
}
